import CustomerNotes from './customer-notes.vue';

export default CustomerNotes;
